function adjustTableHeaderHeight(){
    let wuplusTableHeaderArray = document.querySelectorAll(".wuplus-table-mobile-header-container");
    let tableHeaderHeight = 0;
      Array.from(wuplusTableHeaderArray).forEach((wuplusTableHeaderItem) => {
        wuplusTableHeaderItem.removeAttribute("style");
        tableHeaderHeight = Math.max(
          tableHeaderHeight,
          wuplusTableHeaderItem.clientHeight
        );
      });
      Array.from(wuplusTableHeaderArray).forEach((wuplusTableHeaderItem) => {
        wuplusTableHeaderItem.setAttribute("style", `height:${tableHeaderHeight}px`);
      });
      
}

window.addEventListener("resize",adjustTableHeaderHeight)
adjustTableHeaderHeight();